import React, { useEffect, useCallback } from "react";
import { useStore } from "../../../store/store";
import { useRequiredMsgs } from "../../../store/requiredMsgs";
import {
  slidingScreenDbl,
  slidingScreenRight,
  slidingScreenLeft,
} from "./defaults";

const slidingScreenConfigs = ["OA-XO", "OX-AO", "OX", "XO"];

function useSliderScreenSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const chosenConfig = useStore((state) => state.quote.exactConfig);
  const slidingScreenChoice = useStore((state) => state.quote.addSlidingScreen);

  const screenColorChoice = useStore((state) => state.quote.screenColor);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const slidingScreenImgShown =
    slidingScreenChoice === "Add Double Screen"
      ? "Screens/DURANGO_DOUBLE"
      : slidingScreenChoice === "Add Screen Open Left"
      ? "v1635813267/Screens/DURANGO_LEFT.jpg"
      : slidingScreenChoice === "Add Screen Open Right"
      ? "v1635813265/Screens/DURANGO_RIGHT.jpg"
      : "";

  const findScreenDirection = useCallback(() => {
    if (!slidingScreenConfigs.includes(chosenConfig)) return;

    if (chosenConfig === "OA-XO" || chosenConfig === "OX-AO") {
      return addToQuote({ addSlidingScreen: "Add Double Screen" });
    }
    if (chosenConfig === "OX") {
      return addToQuote({ addSlidingScreen: "Add Screen Open Left" });
    }

    if (chosenConfig === "XO") {
      return addToQuote({ addSlidingScreen: "Add Screen Open Right" });
    }
  }, [chosenConfig]);

  useEffect(() => {
    if (!chosenConfig) return;
    findScreenDirection();
  }, [chosenConfig]);

  const handleClick = (label: string) => {
    const checked = label === screenColorChoice;

    if (checked) {
      addToQuote({ screenColor: "" });
    } else {
      addToQuote({ screenColor: label });
      if (findRequired("Screen Extrusion Color"))
        removeRequired("Screen Extrusion Color");
    }
  };

  const optionsDisplayed = !slidingScreenConfigs.includes(chosenConfig)
    ? []
    : chosenConfig === "OX"
    ? slidingScreenLeft
    : chosenConfig === "XO"
    ? slidingScreenRight
    : slidingScreenDbl;

  return {
    handleClick,
    slidingScreenImgShown,
    chosenConfig,
    screenColorChoice,
    optionsDisplayed,
  };
}

export default useSliderScreenSelector;
